import { Text, Divider, Flex, Box, Img } from '@chakra-ui/react'
import { useTranslation } from 'react-i18next';


function InfoServices() {
    const { t } = useTranslation();
    return (
        <Flex direction={'column'} w={{ base: '100%', md: '50%' }} alignItems={'center'}>

            <Flex w={{ base: '80%', md: '170%', lg: '80%' }}>
                <Text color={'#AE8245'} fontSize={'18px'} textAlign={'left'} fontWeight={'normal'} fontFamily={'Inter'} mr={'1%'}>
                    {t("services-tittle2")}
                </Text>

                <Divider w={'69%'} mt={'1.5%'} display={{base:'none', md:'flex'}}/>
            </Flex>


            <Flex w={{ base: '80%', md: '170%', lg: '80%' }} justifyContent={'center'} gap={'5%'} direction={{ base: 'column', md: 'row' }}>

                <Flex direction={'column'}>
                    <Text color={'white'} fontSize={'18px'} mt={'7%'} fontWeight={'normal'} fontFamily={'Inter'}>

                        {t("services-info2")}

                    </Text>

                    <Text color={'white'} fontSize={'18px'} mt={'7%'} fontWeight={'normal'} fontFamily={'Inter'}>
                       {t("services-info3")}

                    </Text>

                </Flex>

                <Flex direction={'column'}>
                    <Text color={'white'} fontSize={'18px'} mt={'7%'} fontWeight={'normal'} fontFamily={'Inter'}>

                        {t("services-info4")}

                    </Text>

                    <Text color={'white'} fontSize={'18px'} fontWeight={'normal'} fontFamily={'Inter'}>
                        {t("services-info5")}
                    </Text>

                    <Text color={'#AE8245'} fontSize={'18px'} fontWeight={'normal'} fontFamily={'Inter'}>
                        TMG International — reliability from border to
                        border, and beyond.
                    </Text>

                </Flex>

            </Flex>

        </Flex >



    )
}

export default InfoServices